import React from "react";
import LayoutCenter from "../UserInterface/LayoutCenter";

type BlogIframeProps = {
  innerHtml: any;
};

const BlogIframe = ({ innerHtml }: BlogIframeProps) => {
  return (
    <LayoutCenter alignMobile="flex-start" width="100%">
      <div
        className="iframe__wrapper"
        dangerouslySetInnerHTML={{ __html: innerHtml }}
      />

      <style jsx>{`
        .iframe__wrapper {
          margin: 24px 0 0;
          width: 100%;
          text-align: center;
        }
        @media only screen and (max-width: 850px) {
          .iframe__wrapper {
            margin: 24px 24px 0;
            width: calc(100% - 48px);
          }
        }
      `}</style>
    </LayoutCenter>
  );
};

export { BlogIframe };
